import React, {Component} from 'react';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import { app } from '../../../base'

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class ForgotPass extends Component {
  constructor(props) {
    super(props)
    if (sessionStorage.authenticated=="true") {
      this.state = {
        redirect: true
      }
    }
    else {
      this.state = {
        message: '',
        redirect: false,
        show: 'none'
      }
    }
  }

  sendPassword(event) {
    event.preventDefault()

    const email = this.emailInput.value
    app.auth().sendPasswordResetEmail(email)
      .then(() => {
        this.setState({
          message: "Password reset email sent to your email address",
          redirect: false,
          show: '',
        });
      })
      .catch((error) => {
        this.setState({
          message: error.message,
          redirect: false,
          show: '',
        });
    });
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }

    if (this.state.redirect === true) {
      return <Redirect to={from} />
    }
    
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="p-4">
                  <form onSubmit={(event) => { this.sendPassword(event) }} ref={(form) => { this.loginForm = form }}>
                    <ShowMessage show={this.state.show} message={this.state.message} />
                    <CardBody>
                      <h1>Forgot Password?</h1>
                      <p className="text-muted">Enter email address to get back your account</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon>@</InputGroupAddon>
                        <Input name="email" type="text" placeholder="Email"  innerRef={(input) => { this.emailInput = input }} />
                      </InputGroup>
                      <Row>
                        <Col xs="6">
                          <Button color="primary" className="px-4">Submit</Button>
                        </Col>
                        <Col xs="6" className="text-right">
                          <Link to="/login"><Button color="link" className="px-0">Back to Login</Button></Link>
                        </Col>
                      </Row>
                    </CardBody>
                  </form>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ForgotPass;



// WEBPACK FOOTER //
// ./src/views/Pages/ForgotPass/ForgotPass.js